module.exports = __webpack_public_path__ + "static/media/country_mw.379ddeff.webp";